// Central definition of browser-storage key groups for tenant + session
// isolation. Kept in ONE place so the login, logout, api-client and
// tenant-gate paths stay consistent and can't drift — the source of the
// "stale tenant leaks into the next login" and "logout in one tab kills the
// other tab" bugs was scattered, ad-hoc storage handling.

// Tenant / org context (sessionStorage). Purged on a tenant switch and on
// logout so a not-logged-out session can't leak its tenant into the next
// login/invitation.
export const TENANT_KEYS = [
  'mira_client_slug',
  'mira_branch_slug',
  'b2c_organization_id',
  'b2c_branch_id',
  'b2c_loan_officer_id',
];

// A "secondary" (tab-scoped Bearer) session's tokens + markers (sessionStorage).
// Independent of the shared HttpOnly primary cookie — must survive another
// tab's/user's logout.
export const SECONDARY_SESSION_KEYS = [
  'fm_access_token',
  'fm_refresh_token',
  'fm_secondary_session',
  'fm_session_user_id',
];

const removeAll = (keys) => {
  if (typeof sessionStorage === 'undefined') return;
  keys.forEach((k) => {
    try {
      sessionStorage.removeItem(k);
    } catch {
      // storage unavailable (private mode / quota) — best-effort
    }
  });
};

export const clearTenantKeys = () => removeAll(TENANT_KEYS);
export const clearSecondarySessionKeys = () => removeAll(SECONDARY_SESSION_KEYS);

// True when this tab holds its own tab-scoped Bearer session (a "secondary"
// login) — independent of the shared primary cookie.
export const hasSecondarySession = () =>
  typeof sessionStorage !== 'undefined' && !!sessionStorage.getItem('fm_access_token');
